// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__pEWFx","V_left":"Virtual_V_left__O6SJr","img_wrapper":"Virtual_img_wrapper__zBt8t"};